import React from "react";
import { Snackbar, Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const SEVERITY_STYLES = {
  success: {
    bgColor: "#2e7d32",
    icon: <CheckCircleIcon sx={{ color: "#fff" }} />,
    duration: 2500,
  },
  error: {
    bgColor: "#c62828",
    icon: <CancelIcon sx={{ color: "#fff" }} />,
    duration: 6000,
  },
  warning: {
    bgColor: "#ef6c00",
    icon: <WarningAmberIcon sx={{ color: "#fff" }} />,
    duration: 4000,
  },
  info: {
    bgColor: "#455a64",
    icon: <InfoOutlinedIcon sx={{ color: "#fff" }} />,
    duration: 3000,
  },
};

function SnackbarAlert({
  open,
  onClose,
  message,
  severity = "info",
  autoHideDuration,
  bgColor,
}) {
  const defaultStyle = SEVERITY_STYLES[severity] || SEVERITY_STYLES.info;

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration ?? defaultStyle.duration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}>
      <Alert
        onClose={onClose}
        severity={severity}
        icon={defaultStyle.icon}
        sx={{
          width: "100%",
          backgroundColor: bgColor || defaultStyle.bgColor,
          color: "#fff",
          fontWeight: "bold",
          fontSize: "16px",
          textAlign: "center",
        }}>
        {message}
      </Alert>
    </Snackbar>
  );
}

export default SnackbarAlert;
